import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { IsActiveMatchOptions, Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { filter, slice } from 'lodash-es';
import { Subscription } from 'rxjs';

import { IMenuItem } from 'src/app/models/interfaces/IMenuItem';
import { LoggedInUserDto } from 'src/app/models/loggedinUserDto';
import { AuthService } from 'src/app/services/auth.service';

import { UserDropdownComponent } from '../user-dropdown/user-dropdown.component';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent implements OnInit, OnChanges, OnDestroy {

  isLoggedIn: boolean = null;
  loggedInSub: Subscription;
  langSub: Subscription;
  currentLang: string;

  routerMatchOpts: IsActiveMatchOptions = {
    queryParams: 'ignored',
    matrixParams: 'ignored',
    paths: 'subset',
    fragment: 'ignored',
  };

  user: LoggedInUserDto;

  @Input() menuOptions: IMenuItem[] = [];
  leftOptions: IMenuItem[] = [];
  rightOptions: IMenuItem[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    private translationService: TranslateService,
    private popover: PopoverController
  ) { }

  ngOnInit() {
    this.loggedInSub = this.authService.isLoggedIn.subscribe(res => {
      this.isLoggedIn = res;
      if (res === true) {
        this.authService.getUser().then(user => {
          this.user = user;
        });
      } else {
        this.user = null;
      }

      // this.menuOptions = this.generateMenu();
    });
    this.langSub = this.translationService.onLangChange.subscribe(val => {
      this.currentLang = val?.lang;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const activeOptions = filter(this.menuOptions, opt => opt.hidden != true);
    this.leftOptions = filter(activeOptions, opt => opt.dir == 'ls' || opt.dir == null);
    this.rightOptions = filter(activeOptions, opt => opt.dir == 'rs');
  }

  ngOnDestroy(): void {
    this.loggedInSub?.unsubscribe();
    this.langSub?.unsubscribe();
  }

  logout() {
    return this.authService.logout().then(() =>
      this.router.navigate(['/login'])
    );
  }

  async launchPopover(event: any) {
    const popover = await this.popover.create({
      component: UserDropdownComponent,
      cssClass: 'user-popover',
      event: event,
      translucent: true,
      componentProps: {
        dismissPopover: () => {
          popover.dismiss();
        }
      }
    });
    return await popover.present();
  }

  generateMenu() {
    return [
      { icon: 'water', label: 'Classes_Designs', path: ['/designs'], hidden: !this.isLoggedIn },
      { icon: 'pricetags', label: 'Classes_Payback', path: ['/payback'], hidden: !this.isLoggedIn },
      { icon: 'people', label: 'Classes_Customers', path: ['/customers'], hidden: !this.isLoggedIn },
      { icon: 'albums', label: 'Classes_Projects', path: ['/projects'], hidden: !this.isLoggedIn },
      { icon: 'grid', label: 'Classes_Mainlines', path: ['/mainlines'], hidden: !this.isLoggedIn },
      { icon: 'folder', label: 'Messages_CustomProducts', path: ['/laterals'], hidden: !this.isLoggedIn },
      { icon: 'contrast', label: 'Messages_CustomManifolds', path: ['/custom-pipe-sizes'], hidden: !this.isLoggedIn }
    ];
  }

}
